import { 
    Box, 
    Typography, 
    Button, 
    Divider, 
    Grid, 
    useMediaQuery,
    Container,
    Card,
    CardContent,
    Fade,
    useTheme
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Navigation } from "./navigation";
import { Footer } from "./Footer";
import Network from "./network/Network";
import CustomCarousel from "./CustomCarosoul";
import Endpoints, { BASE_URL } from "./network/endpoints";
import instId from "./network/instituteId";
import axios from "axios";
import HomeSection2 from "./homepage/RatingSection";
import FacultySection from "./homepage/FacultyList";
import IframFormSection from "./homepage/IframeSection";

const AboutUs = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
    const [banners, setBanners] = useState([]);
    const [Endpoints, setEndpoints] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        const loadData = async () => {
            setLoading(true);
            await Promise.all([getInstituteDetail(), getBanners()]);
            setLoading(false);
        };
        loadData();
    }, []);

    const getInstituteDetail = async () => {
        try {
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.get(
                BASE_URL + "/getMetaData/fetch-institute/" + instId,
                requestOptions
            );
            if (response?.data?.errorCode === 0) {
                setEndpoints(response?.data?.instituteTechSetting?.mediaUrl);
            }
        } catch (error) {
            console.error('Failed to fetch institute details:', error);
        }
    };

    const getBanners = async () => {
        try {
            const response = await Network.fetchBannerss(instId);
            const fetchedBanners = response.banners || [];
            let resultBanner = [];
            fetchedBanners.forEach((item) => {
                if (item?.group === "About Us") {
                    resultBanner.push(item);
                }
            });
            
            if (resultBanner.length > 0) {
                setBanners(resultBanner);
            } else {
                setBanners([]);
            }
        } catch (error) {
            console.error('Failed to fetch banners:', error);
            setBanners([]);
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.15) 0%, transparent 50%)',
                    pointerEvents: 'none',
                },
            }}
        >
            {/* Hero Section */}
            <Box
                sx={{
                    pt: { xs: 8, md: 8 },
                    pb: { xs: 4, md: 6 },
                    position: 'relative',
                    zIndex: 1,
                    px: { xs: 2, sm: 3, md: 4 },
                }}
            >
                <Box maxWidth="100%">
                    <Fade in timeout={1000}>
                        <Box textAlign="center" mb={{ xs: 4, md: 6 }}>
                            <Typography
                                variant="h2"
                                sx={{
                                    fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                                    fontWeight: 700,
                                    background: 'linear-gradient(45deg, #ffffff 30%, #e2e8f0 90%)',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    mb: 2,
                                    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                }}
                            >
                                About Us
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{
                                    color: 'rgba(255,255,255,0.8)',
                                    fontSize: { xs: '1rem', md: '1.1rem' },
                                    maxWidth: '600px',
                                    mx: 'auto',
                                    lineHeight: 1.6,
                                }}
                            >
                                Discover our journey, mission, and commitment to educational excellence
                            </Typography>
                        </Box>
                    </Fade>

                    {/* Banner Section */}
                    {banners?.length > 0 && (
                        <Fade in timeout={1500}>
                            <Box sx={{ width: '100%' }}>
                                <Grid container spacing={{ xs: 1, md: 2 }}>
                                    {banners.map((item, i) => (
                                        <Grid item xs={12} key={i}>
                                            <Card
                                                sx={{
                                                    background: 'rgba(255, 255, 255, 0.1)',
                                                    backdropFilter: 'blur(20px)',
                                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                                    borderRadius: 3,
                                                    overflow: 'hidden',
                                                    transition: 'all 0.3s ease',
                                                    mx: { xs: 0, sm: 1, md: 2 },
                                                    '&:hover': {
                                                        transform: 'translateY(-8px)',
                                                        boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                                                        background: 'rgba(255, 255, 255, 0.15)',
                                                    },
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        position: 'relative',
                                                        overflow: 'hidden',
                                                        '&::after': {
                                                            content: '""',
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            background: 'linear-gradient(45deg, rgba(0,0,0,0.1) 0%, transparent 100%)',
                                                            pointerEvents: 'none',
                                                        },
                                                    }}
                                                >
                                                    <img
                                                        src={Endpoints + item?.banner}
                                                        alt={`About us banner ${i + 1}`}
                                                        style={{
                                                            width: '100%',
                                                            height: 'auto',
                                                            display: 'block',
                                                            borderRadius: '12px',
                                                            transition: 'transform 0.3s ease',
                                                        }}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                        }}
                                                    />
                                                </Box>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </Fade>
                    )}

                    {/* Loading State */}
                    {loading && (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            minHeight="300px"
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    border: '3px solid rgba(255,255,255,0.1)',
                                    borderTop: '3px solid #ffffff',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite',
                                    '@keyframes spin': {
                                        '0%': { transform: 'rotate(0deg)' },
                                        '100%': { transform: 'rotate(360deg)' },
                                    },
                                }}
                            />
                        </Box>
                    )}

                    {/* Empty State */}
                    {!loading && banners?.length === 0 && (
                        <Fade in timeout={1000}>
                            <Card
                                sx={{
                                    background: 'rgba(255, 255, 255, 0.1)',
                                    backdropFilter: 'blur(20px)',
                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                    borderRadius: 3,
                                    p: { xs: 3, md: 6 },
                                    textAlign: 'center',
                                    mt: 4,
                                    mx: { xs: 0, sm: 1, md: 2 },
                                    width: '100%',
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{
                                        color: 'rgba(255,255,255,0.9)',
                                        mb: 2,
                                        fontSize: { xs: '1.25rem', md: '1.5rem' },
                                    }}
                                >
                                    Coming Soon
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: 'rgba(255,255,255,0.7)',
                                        fontSize: { xs: '0.9rem', md: '1rem' },
                                    }}
                                >
                                    We're preparing something amazing for you. Stay tuned!
                                </Typography>
                            </Card>
                        </Fade>
                    )}
                </Box>
            </Box>

            {/* Additional Sections */}
            <Box sx={{ position: 'relative', zIndex: 1 }}>
                <HomeSection2 endpointsUrl={Endpoints} />
                {/* <FacultySection endpointsUrl={Endpoints} /> */}
                {/* <IframFormSection endpointsUrl={Endpoints} /> */}
            </Box>
        </Box>
    );
};

export default AboutUs;
